export enum TopFilterTypes {
    issuer = "managers",
    arranger = "arrangers",
    staticDeal = "staticDeal",
    trustees = "trustees",
}
